import { useContext } from 'react'
import { ContactSellerModalContext } from './ContactSeller/context/ContactSellerContext'

const CallSellerButtonMobile = () => {
  const phoneNumber = App.State.ownerPhoneNumber
  const { openContactModal } = useContext(ContactSellerModalContext)

  const handleClick = () => {
    if (!App.State.userId) {
      openContactModal()
    }
  }

  return (
    <a
      href={App.State.userId ? `tel:${phoneNumber}` : '#'}
      className={`btn btn-primary w-100 ${!phoneNumber && 'disabled'} ga-event rounded-8`}
      rel="nofollow"
      data-ga-event={JSON.stringify({
        category: 'Car Page',
        action: 'Click Call (mobile)',
      })}
      onClick={handleClick}
    >
      <i className="fas fa-phone me-1 fa-lg" />
    </a>
  )
}

export default CallSellerButtonMobile
